import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "es",
	supportedLngs: ["es", "en", "pt"],
	load: "languageOnly",
	ns: ["translations"],
	resources: messages,
	detection: {
		order: ['localStorage', 'navigator'],
		caches: ['localStorage'],
	},
	interpolation: {
		escapeValue: false,
	},
});

export { i18n };
